<template>
	<div v-if="is_dragging"
		class="gb-photoalbum-drop primary"
		v-bind:style = "styleContent">
		<div class="content">
			<img 
				src="../../assets/cloud-upload.png"
				style="margin-bottom:50px">
			<div>
				<h1>画像をドロップするとアップロードできます</h1>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'GBPhotoAlbumDrop',
	data() {
		return {
			is_dragging: false,
		};
	},
	methods: {
		onDrop: function(e) {
			e.preventDefault();
			
			this.is_dragging = false;
			this.$emit('drop', e);
		},
		onDragOver: function(e) {
			e.preventDefault();
		},
		onDragLeave: function(e) {
			e.preventDefault();
			if(e.relatedTarget !== null)
				return ;
			this.onDrag(e, false);
		},
		onDragEnter: function(e) {
			e.preventDefault();
			this.onDrag(e, true);
		},
		onDrag: function(e, status) {
			if (!e.dataTransfer.types.includes('Files'))
				return;

			this.is_dragging = status;
		},
	},
	computed:{
		styleContent: function() {
			return {
				height: this.$store.getters.height + 'px',
			};
		}
	},
	created: function() {
		window.addEventListener('drop', this.onDrop, false);
		window.addEventListener('dragover', this.onDragOver, false);
		window.addEventListener('dragleave', this.onDragLeave, false);
		window.addEventListener('dragenter', this.onDragEnter, false);
	},
	beforeDestroy: function() {
		window.removeEventListener('drop', this.onDrop);
		window.removeEventListener('dragover', this.onDragOver);
		window.removeEventListener('dragleave', this.onDragLeave);
		window.removeEventListener('dragenter', this.onDragEnter);
	},
};
</script>
<style>
	.gb-photoalbum-drop {
		position: relative;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		overflow-y: hidden;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
	}
	.gb-photoalbum-drop .content {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		width: 100%;
		height:50%;
		text-align: center;
		color: #FFF;
	}
</style>

